import React from "react";

import { ProtectedRoute } from "components/ProtectedRoute";
import { DeviceProvider } from "contexts/DeviceContext";
import { ConfigureIR } from "./ConfigureIR";
import { CONFIGURE_IR } from "routers/routePaths";

export const DevicesRouter = () => {
  return (
    <DeviceProvider>
      <ProtectedRoute exact path={CONFIGURE_IR}>
        <ConfigureIR />
      </ProtectedRoute>
    </DeviceProvider>
  );
};
